/**
 * Numbers typed in the admin forms. `null` = left empty (cleared),
 * `undefined` = not a number or out of bounds: the form refuses to save
 * rather than sending a cleared value, what `parseFloat` makes of "12abc",
 * or a value the server's `@Max` would refuse with a bare 400.
 */
// Same bound as the client amounts' `@Max` on the server.
export const MAX_AMOUNT = 100_000;

export function parseAmount(
  value: string,
  max: number = MAX_AMOUNT,
): number | null | undefined {
  const text = value.trim().replace(",", ".");
  if (text === "") return null;
  const amount = Number(text);
  return Number.isFinite(amount) && amount >= 0 && amount <= max
    ? amount
    : undefined;
}

export function parseCount(
  value: string,
  max: number = Number.MAX_SAFE_INTEGER,
): number | null | undefined {
  const count = parseAmount(value, max);
  return count == null || Number.isInteger(count) ? count : undefined;
}

/** Server-side `MaxLength`s, mirrored on the inputs. */
export const MAX_LENGTH = { name: 200, short: 100, notes: 20_000 } as const;
